// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import Chart from 'chart.js'
Vue.use(BootstrapVue)
Vue.config.productionTip = false

Chart.defaults.global.defaultFontFamily = "'Rubik', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App ref="app"/>',
  components: { App },
  methods: {
    showToast (message) {
      this.$refs.app.showToast(message)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js